<template>
  <bita-modal
    :id="modalId"
    :title="title"
    :modal-lg="true"
    :isLoading="isLoading"
    @close="onCloseModal"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <div class="col-12">
              <div class="alert alert-primary" role="alert">
                اطلاعات شخصی
                {{
                  dataForm.activation_code && `(${dataForm.activation_code})`
                }}
              </div>
            </div>
            <bita-input
              type="text"
              name="name"
              label="نام"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.name"
            />
            <bita-input
              type="text"
              name="family"
              label="نام خانوادگی"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.family"
            />
            <bita-input
              type="number"
              name="national_code"
              label="کدملی"
              rules="required||irani"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.national_code"
            />
            <bita-input
              type="number"
              name="ssn_number"
              label="شماره شناسنامه"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.ssn_number"
            />
            <bita-input
              type="text"
              name="phone"
              label="شماره تماس"
              rules="required|mobile"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.phone"
            />
            <bita-input
              v-if="!propsData.id"
              type="password"
              name="password"
              label="رمزعبور"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.password"
            />
            <bita-input
              type="postal_code"
              name="postal_code"
              label="کد پستی"
              rules=""
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.postal_code"
            />
            <bita-textarea
              label="آدرس"
              name="address"
              class="col-12"
              inputClass="col-12 form-control"
              rules=""
              place-holder="آدرس"
              v-model="dataForm.address"
            />
            <div class="col-12">
              <div class="alert alert-primary" role="alert">اطلاعات راننده</div>
            </div>
            <div :class="colWidth">
              <plate-number-inputes
                ref="plate"
                v-model="dataForm.number_plate"
              />
            </div>
            <bita-input
              type="car_smartnumber"
              name="car_smartnumber"
              label="شماره هوشمند ماشین"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.car_smartnumber"
            />
            <bita-input
              type="driver_smartnumber"
              name="driver_smartnumber"
              label="شماره هوشمند راننده"
              rules=""
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.driver_smartnumber"
            />
            <bita-input
              type="certificate_number"
              name="certificate_number"
              label="شماره گواهینامه"
              rules=""
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.certificate_number"
            />
            <bita-select
              type="vehicle_type_parent"
              name="vehicle_type_parent"
              label="دسته بندی نوع ماشین"
              :validation-container-class="colWidth"
              :data-source="propsVehicleTypeParent"
              data-text-field="name"
              data-value-field="id"
              v-model="dataForm.vehicle_type_parent_id"
              @change="getVehicleType"
            />
            <Spinner
              :is-loading="isLoadingVehicleType"
              :class-name="colWidth"
              styleName="align-self: center;"
            />
            <bita-select
              v-show="isLoadingVehicleType === false"
              type="vehicle_type"
              name="vehicle_type"
              label="نوع ماشین"
              :validation-container-class="colWidth"
              :data-source="vehicleType"
              data-text-field="name"
              data-value-field="id"
              v-model="dataForm.vehicle_type_id"
            />
          </div>
        </div>
      </bita-form>
    </div>
    <div slot="footer">
      <bita-bootbutton
        v-if="!propsData.id"
        type="primary"
        title="ذخیره"
        icon="fa fa-check"
        btn-width="150px"
        @click.native="handleSubmit()"
      />
      <bita-bootbutton
        v-if="propsData.id"
        type="primary"
        title="بروزرسانی"
        icon="fa fa-check"
        btn-width="150px"
        @click.native="handleSubmit()"
      />
      <bita-bootbutton
        class="mr-2"
        type="danger"
        title="بستن"
        icon="fas fa-times"
        btn-width="150px"
        data-dismiss="modal"
        @click.native="
          () => {
            $emit('change-status-modal');
          }
        "
      />
    </div>
  </bita-modal>
</template>

<script>
import Spinner from "../../../components/Spinner";
import PlateNumberInputes from "./../../../components/PlateNumberInputs";
import { width } from "@amcharts/amcharts4/.internal/core/utils/Utils";

export default {
  components: { Spinner, PlateNumberInputes },
  props: {
    modalId: {},
    isLoading: {},
    title: {},
    onSubmit: {},
    propsVehicleTypeParent: {},
    propsVehicleType: {},
    propsData: {
      type: Object,
      default: {
        id: 0,
        name: "",
        family: "",
        national_code: "",
        ssn_number: "",
        phone: "",
        postal_code: "",
        address: "",
        password: "",
        number_plate: "",
        car_smartnumber: "",
        driver_smartnumber: "",
        certificate_number: "",
        activation_code: "",
      },
    },
  },
  data() {
    return {
      colWidth: "col-lg-4 col-md-6 col-sm-6",
      dataForm: {},
      vehicleType: [],
      isLoadingVehicleType: false,
    };
  },
  watch: {
    propsData: function(_data) {
      this.dataForm = _data;
    },
    propsVehicleType: function(_data) {
      this.vehicleType = _data;
    },
  },
  methods: {
    width,
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        // this.$refs.plate.validate().then(() => {
        if (result) {
          this.$emit("on-submit", this.dataForm);
        }
        // });
      });
    },
    reset() {
      this.$refs.form.reset();
      // this.$refs.plate.resetValidation();
      this.dataForm = {};
    },
    onCloseModal(e) {
      this.reset();
    },
    getVehicleType(e) {
      this.isLoadingVehicleType = true;
      this.dataForm.vehicle_type_id = null;
      this.$persistClient("get", `vehicle-types?filter[parent]=${e}`).then(
        (res) => {
          this.vehicleType = res.data;
          this.isLoadingVehicleType = false;
        }
      );
    },
  },
};
</script>
